import { IHorario } from 'Models/docas'
import moment from 'moment'

const classificacaoHorarios = {
  comparaHorariosAsc(horario1: IHorario, horario2: IHorario): number {
    const dtHora1 = moment(horario1.dtHora, 'YYYY-MM-DDTHH:mm:ss')
    const dtHora2 = moment(horario2.dtHora, 'YYYY-MM-DDTHH:mm:ss')

    return dtHora1.isBefore(dtHora2) ? -1 : 1
  },

  comparaHorariosDesc(horario1: IHorario, horario2: IHorario): number {
    const dtHora1 = moment(horario1.dtHora, 'YYYY-MM-DDTHH:mm:ss')
    const dtHora2 = moment(horario2.dtHora, 'YYYY-MM-DDTHH:mm:ss')

    return dtHora1.isAfter(dtHora2) ? -1 : 1
  },

  buscaUltimoHorario(cdJanela: number, horarios: IHorario[]): moment.Moment {
    const horariosJanela = horarios
      .filter((horario) => horario.cdAgendamentoDocasJanela === cdJanela)
      .sort(this.comparaHorariosDesc)

    return moment(horariosJanela[0].dtHora, 'YYYY-MM-DDTHH:mm:ss')
  },

  ordenaHorarios(horarios: IHorario[], asc = true): IHorario[] {
    let horariosOrdenados: IHorario[] = [...horarios]

    horariosOrdenados = asc
      ? horariosOrdenados.sort(this.comparaHorariosAsc)
      : horariosOrdenados.sort(this.comparaHorariosDesc)

    return horariosOrdenados
  },

  verificaHorariosConsecutivos(
    horarios: IHorario[],
    tamanhoJanelaSecundariaMinutos: number,
  ): boolean {
    if (horarios.length > 1) {
      const cdDoca: number = horarios[0].cdAgendamendoDocasDocas

      if (
        horarios.some((horario) => horario.cdAgendamendoDocasDocas !== cdDoca)
      ) {
        return false
      }

      let horariosOrdenados: IHorario[] = [...horarios]
      horariosOrdenados = horariosOrdenados.sort(this.comparaHorariosAsc)

      for (let i = 1; i < horariosOrdenados.length; i++) {
        const dtHora1: moment.Moment = moment(
          horariosOrdenados[i - 1].dtHora,
          'YYYY-MM-DDTHH:mm:ss',
        )
        const dtHora2: moment.Moment = moment(
          horariosOrdenados[i].dtHora,
          'YYYY-MM-DDTHH:mm:ss',
        )

        if (
          dtHora2.diff(dtHora1, 'minutes') !== tamanhoJanelaSecundariaMinutos
        ) {
          return false
        }
      }
    }

    return true
  },
}

export default classificacaoHorarios
